import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RedirectService {
    private redirectUrl: string | null = null;

    constructor(private router: Router) {}

    /**
     * Store the URL to redirect to after login
     */
    setRedirectUrl(url: string) {
        console.log('RedirectService: Setting redirect URL:', url);
        this.redirectUrl = url;
    }

    /**
     * Get the stored redirect URL
     */
    getRedirectUrl(): string | null {
        return this.redirectUrl;
    }

    /**
     * Clear the stored redirect URL
     */
    clearRedirectUrl() {
        console.log('RedirectService: Clearing redirect URL');
        this.redirectUrl = null;
    }

    /**
     * Navigate to the stored redirect URL if one exists, otherwise navigate to default
     */
    redirectAfterLogin(defaultUrl: string = '/') {
        const url = this.redirectUrl || defaultUrl;
        console.log('RedirectService: Redirecting to:', url);
        this.clearRedirectUrl();
        this.router.navigateByUrl(url);
    }

    /**
     * Check if there is a pending redirect
     */
    hasPendingRedirect(): boolean {
        return this.redirectUrl !== null;
    }
}
